"use client";

import { useId, useState, type ReactNode } from "react";
import { buttonClass } from "@/components/ui/button";
import { IconChevronDown } from "@/components/ui/icons";

/**
 * Uzun ızgara listesi: ilk `limit` öğe (mobilde `mobileLimit`) görünür, kalanlar "Tümü (n)" düğmesiyle aynı yerde
 * açılır (düğme aria-expanded + aria-controls; açılınca "Daha az göster"). Öğeler sunucuda çizilir ve hep DOM'dadır;
 * kapalıyken fazlası `hidden` (ekran okuyucu ve sekme sırası dışı). Liste sınırı aşmıyorsa düğme yok.
 */
export function ExpandableList({
  items,
  limit,
  mobileLimit = limit,
  label,
  className,
  showAll,
  showFewer,
}: {
  /** Her biri bir <li> içeriği */
  items: { key: string; node: ReactNode }[];
  limit: number;
  mobileLimit?: number;
  label: string;
  className: string;
  /** "Tüm destinasyonlar (20)" */
  showAll: string;
  showFewer: string;
}) {
  const [open, setOpen] = useState(false);
  const id = useId();
  const overflow = items.length > Math.min(limit, mobileLimit);
  // Masaüstünde gizli öğe yoksa (yalnızca mobilde fazlası var) düğme sm ve üstünde gizli
  const desktopOverflow = items.length > limit;
  return (
    <div>
      <ul id={id} className={className} aria-label={label}>
        {items.map((it, i) => {
          const hide = open ? "" : i >= limit ? "hidden" : i >= mobileLimit ? "max-sm:hidden" : "";
          return (
            <li key={it.key} className={`min-w-0 ${hide}`}>
              {it.node}
            </li>
          );
        })}
      </ul>
      {overflow && (
        <div className={`mt-4 flex justify-center ${desktopOverflow ? "" : "sm:hidden"}`}>
          <button type="button" aria-expanded={open} aria-controls={id} onClick={() => setOpen(!open)} className={buttonClass("secondary", "md")}>
            {open ? showFewer : showAll}
            <IconChevronDown size={18} className={`transition-transform ${open ? "rotate-180" : ""}`} />
          </button>
        </div>
      )}
    </div>
  );
}
